<template>
  <v-container fill-height fluid grid-list-md class="custom--container">
    <!-- REMOVED: (for identical tiles) cols="12" sm="3" md="3" -->
    <v-row align-center justify="center">
      <v-col cols="8" offset="2" align="center" justify="center">
        <node />
        <connector />
        <node />
        <connector />
        <node />
      </v-col>
      <scroll-helper v-bind:scroll="scroll" />
    </v-row>
  </v-container>
</template>

<script>
import ScrollHelper from "../ScrollHelper.vue";
import Connector from "./Connector.vue";
import Node from "./Node.vue";
export default {
  name: "Timeline",
  props: ["timelineItems", "scroll"],
  components: { Connector, Node, ScrollHelper },
  data: () => ({
    connectorHeight: 100,
  }),
  mounted() {
    this.connectorHeight =
      this.timelineItems && this.timelineItems.length > 0
        ? Math.round(100 / this.timelineItems.length)
        : this.connectorHeight;
  },
  methods: {
    getConnector() {
      console.log("Get connector");
      return (
        <div
          class="timeline-connector align-center"
          data-aos="zoom-in"
          data-aos-once="false"
        />
      );
    },
    getExpandableNode() {
      return (
        <div
          class="timeline-node align-center"
          data-aos="zoom-in"
          data-aos-once="false"
        />
      );
    },
  },
};
</script>
